<section
  class="flex min-h-screen flex-col items-center justify-center bg-slate-100 px-4"
>
  <h1 class="mb-2 text-4xl font-bold text-slate-900">Bienvenido</h1>
  <p class="mb-6 text-base text-slate-600">Panel para gestionar empresas</p>
  <button
    [routerLink]="['/dashboard/empresas']"
    class="rounded-lg bg-slate-900 px-6 py-3 text-base font-medium text-white transition hover:bg-slate-700"
  >
    Ir a empresas
  </button>
</section>
